export const environment = {
    production: false,
    apiUrl: 'https://test-oopsgateway.azurewebsites.net/api'
  };
  